import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ListHerdAnimals from './ListHerdAnimals.js';
import AddBirth from '../births/AddBirth.js';
import Upload from '../../shared/Upload.js';
import { Fetch } from '../../utils/Utils.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';
import { HerdLotDropdown } from '../lots/HerdLotDropdown.js';
import '../../weight/lots/WeightLots.css';

export const HerdAnimalsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton   isActive={screen === 'list'}   onClick={() => setScreen('list')} />
    <AddButton    isActive={screen === 'add'}    onClick={() => setScreen('add')} />
    <UploadButton isActive={screen === 'upload'} onClick={() => setScreen('upload')} />
    <DownloadButton collection="births" />
  </div>
);

const HerdAnimals = ({ screen, setScreen, actions, initialLotFilter, initialSexFilter }) => {
  const { t } = useTranslation();
  const [localScreen, setLocalScreen] = useState('list');
  const [areas,       setAreas]       = useState([]);
  const [breeds,      setBreeds]      = useState([]);
  const [uploadLotId,      setUploadLotId]      = useState('');
  const [showUploadLotPicker, setShowUploadLotPicker] = useState(false);

  const currentScreen    = screen    !== undefined ? screen    : localScreen;
  const setCurrentScreen = setScreen !== undefined ? setScreen : setLocalScreen;

  useEffect(() => {
    Fetch('api/data/areas',  'get', null, (d) => setAreas(d || []),  () => {});
    Fetch('api/data/breeds', 'get', null, (d) => setBreeds(d || []), () => {});
  }, []);

  const birthDataModel = useMemo(() => [
    { field: 'tag',               type: 'number',  descriptionKey: 'upload_desc_tag',        range: [0, 99999999], required: true },
    { field: 'dam',               type: 'number',  descriptionKey: 'upload_desc_dam',        range: [0, 99999999] },
    { field: 'breed',             type: 'enum',    descriptionKey: 'upload_desc_breed',      values: breeds.map(b => b.name) },
    { field: 'sex',               type: 'enum',    descriptionKey: 'upload_desc_sex',        values: ['m', 'f'] },
    { field: 'area',              type: 'enum',    descriptionKey: 'upload_desc_area',       values: areas.map(a => a.name) },
    { field: 'cause',             type: 'enum',    descriptionKey: 'upload_desc_cause',      values: ['viva','aborto','morreu','morto','nasceu-morto','natimorto','natimortos','other'] },
    { field: 'birth_date',        type: 'date',    descriptionKey: 'upload_desc_date' },
    { field: 'registration_date', type: 'date',    descriptionKey: 'upload_desc_date' },
    { field: 'is_alive',          type: 'boolean', descriptionKey: 'upload_desc_is_alive',    default: true },
    { field: 'is_pregnant',       type: 'boolean', descriptionKey: 'upload_desc_is_pregnant', default: false },
  ], [areas, breeds]);

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}
      {currentScreen === 'list' && (
        <>
          <ListHerdAnimals initialLotFilter={initialLotFilter} initialSexFilter={initialSexFilter} />
          <FAB onClick={() => setCurrentScreen('add')} />
        </>
      )}
      {currentScreen === 'add' && (
        <AddBirth onSuccess={() => setCurrentScreen('list')} />
      )}
      {currentScreen === 'upload' && (
        <Upload
          collection="births"
          displayName="herd"
          dataModel={birthDataModel}
          onSuccess={() => { setUploadLotId(''); setShowUploadLotPicker(false); setCurrentScreen('list'); }}
          extraFields={uploadLotId ? { herd_lot_id: parseInt(uploadLotId, 10) } : {}}
          step0Extra={
            <div style={{ marginTop: 10 }}>
              <button type="button" className="wl-lot-toggle-btn"
                onClick={() => { setShowUploadLotPicker(v => !v); setUploadLotId(''); }}>
                {showUploadLotPicker ? `↩ ${t('use_default_lot')}` : `+ ${t('add_to_specific_lot')}`}
              </button>
              {showUploadLotPicker && (
                <HerdLotDropdown
                  selected={uploadLotId}
                  onChange={e => setUploadLotId(e.target.value)}
                />
              )}
            </div>
          }
        />
      )}
    </>
  );
};

export default HerdAnimals;
